(function () {
  function findConsentCheckbox(root) {
    const wrap = root.querySelector('[data-customs-consent]');
    if (!wrap) return null;
    return wrap.querySelector('input[type="checkbox"]');
  }

  function isAddToCartButton(btn) {
    if (!btn) return false;

    // Common theme selectors/classes
    const cls = btn.className || '';
    const nameAttr = (btn.getAttribute && btn.getAttribute('name')) || '';
    const idAttr = (btn.id || '');

    // Text match (handles your <span>Add to cart</span>)
    const text = (btn.textContent || '').trim().toLowerCase();

    // Many themes: product-form submit button
    if (cls.includes('product-form') || cls.includes('product-form__submit')) return true;

    // Some themes: name="add"
    if (nameAttr.toLowerCase() === 'add') return true;

    // Some themes: id includes add-to-cart
    if (idAttr.toLowerCase().includes('add')) return true;

    // Text-based fallback
    if (text === 'add to cart' || text.includes('add to cart')) return true;

    return false;
  }

  function getAllCandidateButtons() {
    // Grab all clickable controls that might represent Add to cart / Buy now.
    // Essence sometimes uses custom elements or wrappers, so we cast a wide net.
    const buttons = Array.from(
      document.querySelectorAll('button, input[type="submit"], input[type="button"]')
    );

    // Dynamic checkout containers/buttons
    const paymentContainers = Array.from(document.querySelectorAll('.shopify-payment-button'));
    const paymentInnerButtons = Array.from(
      document.querySelectorAll('.shopify-payment-button__button, .shopify-payment-button__more-options')
    );

    // Filter likely Add to cart buttons
    const addToCartButtons = buttons.filter((b) => isAddToCartButton(b));

    return { addToCartButtons, paymentContainers, paymentInnerButtons };
  }

  function setDisabled(el, disabled) {
    if (!el) return;

    // If it supports disabled, set it
    if ('disabled' in el) el.disabled = disabled;

    // Also block pointer interactions (works even for wrappers)
    el.setAttribute('aria-disabled', String(disabled));
    el.style.pointerEvents = disabled ? 'none' : '';
    el.style.opacity = disabled ? '0.5' : '';
    el.style.cursor = disabled ? 'not-allowed' : '';
    el.tabIndex = disabled ? -1 : 0;
  }

  function init() {
    const checkbox = findConsentCheckbox(document);
    if (!checkbox) return;

    function applyState() {
      const enabled = checkbox.checked;
      const { addToCartButtons, paymentContainers, paymentInnerButtons } = getAllCandidateButtons();

      // Disable Add to cart
      addToCartButtons.forEach((btn) => setDisabled(btn, !enabled));

      // Disable dynamic checkout
      paymentContainers.forEach((el) => setDisabled(el, !enabled));
      paymentInnerButtons.forEach((el) => setDisabled(el, !enabled));
    }

    // Initial lock
    applyState();

    checkbox.addEventListener('change', applyState);

    // HARD BLOCK: prevent clicks on add-to-cart buttons if unchecked (even if theme re-enables them)
    document.addEventListener(
      'click',
      function (e) {
        if (checkbox.checked) return;

        const target = e.target;
        if (!target) return;

        // If click is inside a button that looks like Add to cart, block it
        const btn = target.closest && target.closest('button, input[type="submit"], input[type="button"]');
        if (btn && isAddToCartButton(btn)) {
          e.preventDefault();
          e.stopPropagation();
          checkbox.focus({ preventScroll: false });
        }
      },
      true // capture phase to beat theme handlers
    );

    // If the theme dynamically swaps buttons (variant change), re-apply state
    const mo = new MutationObserver(function () {
      applyState();
    });

    mo.observe(document.documentElement, { childList: true, subtree: true });

    // Theme editor section reloads
    document.addEventListener('shopify:section:load', function () {
      applyState();
    });
  }

  document.addEventListener('DOMContentLoaded', init);
})();
